import React from 'react';

const DynamicTag: React.FC<any> = ({ tag = 'div', children, ...props }) => {
  return React.createElement(tag, props, children);
}

export default DynamicTag;
